import { render, staticRenderFns } from "./registration-from-qr.vue?vue&type=template&id=6a1ed612&scoped=true&"
import script from "./registration-from-qr.vue?vue&type=script&lang=js&"
export * from "./registration-from-qr.vue?vue&type=script&lang=js&"
import style0 from "./registration-from-qr.vue?vue&type=style&index=0&id=6a1ed612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ed612",
  null
  
)

export default component.exports